// This mixin is used everywhere where a widget requires time relative querying

import moment from 'moment'

const DEFAULT_FORMAT = 'YYYY-MM-DD 00:00 Z'

// @vue/component
export default {
  methods: {
    // Returns today minus period days in a form of "YYYY-MM-DD"
    from: period => moment().subtract(period, 'days').format(DEFAULT_FORMAT)
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/dashboard/widgets/widgets/mixins/WidgetPeriodMixin.js